var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("StoreConnectedInputGroup", {
    staticClass:
      "input-group search__container section__search fuel-utilization__search-bar",
    attrs: {
      "addon-class": "search__button",
      "input-class": "search__input",
      store: _vm.store,
      name: _vm.name,
      action: _vm.action,
      icon: _vm.icon,
      placeholder: "Search..."
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }